import URI from "urijs";

import type { URITemplateInput } from "urijs/src/URITemplate";
// URITemplate monkey-patches to add the `URI.expand()` function
import "urijs/src/URITemplate";

const URIExpand = (template: string, vals: URITemplateInput): URI => {
  return URI.expand!(template, vals) as unknown as URI;
};

export default URIExpand;
